import React from 'react';
import NavigationBar from '../../Shared/NavigationBar/NavigationBar';

const Blog = () => {
    return (
        <div>
            <NavigationBar/>
            <h1 className="text-center mt-5">No Blog written yet</h1>
        </div>
    );
};

export default Blog;